import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const FarmerProductwiseGoodsIssueReportFMN = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
 const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    // console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const [currencyCode, setCurrencyCode] = useState("");

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter =urlfilter+ `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (stateName && typeof stateName === "string" && stateName.trim().length > 0) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.Fdate.value).format("DD/MM/YYYY")}`;
    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.Tdate.value).format("DD/MM/YYYY")}`;

    var url = `/api/goodsIssueProductReportfmn/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        // console.log("reportdata", data);

        var goodsIssueData = data;

        setData(goodsIssueData);
        //   var newList = [];
        //   var i=0;
        //   if(goodsIssueData.length>0)
        //   {

        //   do {
        //     var farmeritem = goodsIssueData[i];

        //     var strgoodsIssue = JSON.stringify(farmeritem.goodsIssue);

        //     var goodsIssue = (JSON.parse(strgoodsIssue))

        //     //console.log("farmeritem", farmeritem);
        //     //console.log("strgoodsIssue", farmeritem.goodsIssue);

        //      var j = 0;
        //     if(goodsIssue.length>0)
        //     {
        //   do {

        //      var goodsIssueitem=goodsIssue[j];
        //      var strproductDetails=JSON.stringify(goodsIssueitem.productDetails);
        //      var productDetails=JSON.parse(JSON.parse(strproductDetails));
        //      //console.log("goodsIssueitem", goodsIssueitem);

        //        newList = newList.concat({
        //       linesrno: j + 1,

        //       executiveName: farmeritem.executiveName,

        //       regionName: farmeritem.regionName,
        //       farmerCode: farmeritem.farmerCode,
        //       farmerName: farmeritem.farmerName,

        //       goodsIssueDate  : goodsIssueitem. goodsIssueDate,
        //       totalAmount  : goodsIssueitem. totalAmount,
        //       discountAmount  : goodsIssueitem. discountAmount,
        //       discount : goodsIssueitem. discount,

        //     });
        //     j++;
        //   } while (goodsIssue.length > j);

        // }
        //     i++;
        //   } while (goodsIssueData.length > i);
        // }
        //   setData(newList);
      }
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  const fieldsToExport = [
    "farmerName",
    "farmerCode",
    "executiveName",
    "goodsIssueDate",
    "productName",
    "useQty",
    "unit",
    "salesRate",
    "useAmt",
    "createdDate",
  ];

  const customHeaders = [
    "Farmer Name",
    "Farmer Code",
    "Executive Name",
    "Goods Issue Date",
    "Product Name",
    "Quantity",
    "Unit",
    "Sales Rate",
    "Total Amount",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "FarmerGoodsIssuedReport.xlsx";
    //console.log(fieldsToExport,customHeaders);
    const processedData = data.map((item) => ({
      ...item,
      createdDate: item.createdDate ? new Date(item.createdDate).toLocaleDateString("en-GB") : "",
      goodsIssueDate: item.goodsIssueDate ? new Date(item.goodsIssueDate).toLocaleDateString("en-GB") : "",
    }));
    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Goods Productwise Issued Detail Reports
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <hr />

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Fdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Tdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      {/* <table className="table table-bordered table-responsive text-center table-sm"> */}
                      <thead>
                        <tr className="table-header">
                          <th>Farmer Name</th>
                          <th>Farmer Code</th>
                          <th>Executive Name</th>

                          <th> Goods Issue Date</th>
                          <th> Product Name </th>
                          <th> Quantity</th>
                          <th> Unit</th>
                          <th> Sales Rate</th>
                          <th> Total Amount</th>
                          <th> Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerCode}</td>
                                <td>{itm.executiveName}</td>

                                <td>{new Date(itm.goodsIssueDate).toLocaleDateString()}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.useQty}</td>
                                <td>{itm.unit}</td>
                                <td>{parseFloat(itm.salesRate).toFixed(2)}</td>
                                <td>
                                  {" "}
                                  {parseFloat(itm.useAmt || 0).toFixed(2)}
                                </td>
                                <td>{new Date(itm.createdDate).toLocaleDateString()}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerProductwiseGoodsIssueReportFMN;
